// src/pages/ProfileGate/steps/FocusStep.jsx

import React, {
  useState,
} from "react";

import {
  useNavigate,
} from "react-router-dom";

import {
  OnboardingInterstitial,
} from "../OnboardingVisuals";

import {
  GWIN_FOCUS_OPTIONS,
  useProfileGateDraft,
} from "../../../hooks/useProfileGateDraft";

import {
  saveOnboardingDraftProgress,
} from "../../../lib/onboarding/profileGate";

const FOCUS_PENGUIN_URL =
  "https://kwbgrjakobarqelunebd.supabase.co/storage/v1/object/public/pictures/MVP4/Onboarding/Gwin_Book.png";

export default function FocusStep() {
  const navigate =
    useNavigate();

  const {
    loading,
    draft,
    setField,
  } =
    useProfileGateDraft();

  const [
    saving,
    setSaving,
  ] = useState(false);

  const [
    error,
    setError,
  ] = useState("");

  if (loading) {
    return null;
  }

  const selectedFocus =
    Array.isArray(
      draft.business_priorities
    )
      ? draft
          .business_priorities[0] ||
        ""
      : "";

  const canContinue =
    Boolean(
      selectedFocus
    );

  const handleSelect = (
    value
  ) => {
    setError("");

    setField(
      "business_priorities",
      [value]
    );
  };

  const handleContinue =
    async () => {
      if (
        !canContinue ||
        saving
      ) {
        return;
      }

      try {
        setSaving(true);
        setError("");

        await saveOnboardingDraftProgress(
          {
            ...draft,

            business_priorities: [
              selectedFocus,
            ],
          },
          {
            resumeStep:
              "business-basics",
          }
        );

        navigate(
          "/profile-gate/business-basics"
        );
      } catch (err) {
        console.error(
          "Could not save onboarding focus:",
          err
        );

        setError(
          err?.message ||
            "Could not save your answer. Please try again."
        );
      } finally {
        setSaving(false);
      }
    };

  return (
    <OnboardingInterstitial
      message="What would you like Gwin to help you with first?"
      secondaryMessage="Choose one."
      showBack={true}

      
      showSpeechPenguin={true}
      speechPenguinUrl={
        FOCUS_PENGUIN_URL
      }
      speechPenguinClassName="
        w-[105px]
        sm:w-[125px]
        md:w-[140px]
      "

      nextLabel={
        saving
          ? "Saving..."
          : "Continue"
      }
      nextDisabled={
        !canContinue ||
        saving
      }
      onBack={() =>
        navigate(
          "/profile-gate/get-started"
        )
      }
      onNext={
        handleContinue
      }
    >
      <div className="mx-auto mt-7 w-full max-w-[520px]">
        <div className="space-y-3">
          {GWIN_FOCUS_OPTIONS.map(
            (
              option
            ) => {
              const selected =
                selectedFocus ===
                option;

              return (
                <button
                  key={
                    option
                  }
                  type="button"
                  onClick={() =>
                    handleSelect(
                      option
                    )
                  }
                  className={[
                    "w-full rounded-[18px] border-2 px-4 py-4 text-left",
                    "text-[15px] font-semibold leading-snug transition",

                    selected
                      ? "border-[#FF914D] bg-[#FFF4EC] text-[#333333]"
                      : "border-[#E7E7E7] bg-white text-[#555555] hover:border-[#FF914D]/60",
                  ].join(
                    " "
                  )}
                >
                  <div className="flex items-center gap-3">
                    <span
                      className={[
                        "flex h-5 w-5 shrink-0 items-center justify-center rounded-full border-2",

                        selected
                          ? "border-[#FF914D] bg-[#FF914D]"
                          : "border-[#BCBCBC] bg-white",
                      ].join(
                        " "
                      )}
                    >
                      {selected ? (
                        <span className="h-2 w-2 rounded-full bg-white" />
                      ) : null}
                    </span>

                    <span>
                      {option}
                    </span>
                  </div>
                </button>
              );
            }
          )}
        </div>

        {error ? (
          <p className="mt-4 text-center text-sm font-medium text-red-600">
            {error}
          </p>
        ) : null}
      </div>
    </OnboardingInterstitial>
  );
}